import Header from './components/Header'
import AboutPresentation from './components/about/aboutPresentation'
import AboutContent from './components/about/aboutContent'
import FooterNew from './components/FooterNew'


function About() {


  return (
    <>
      <Header/>
      <AboutPresentation/>
      <AboutContent/>
      <FooterNew/>
    </>
  )
}

export default About